// extracted by mini-css-extract-plugin
export default {"searchInput":"id_searchInput__PbxD4"};